import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Asset } from '../v2/components/Asset'
import { Page, Asset as AssetType } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type SplitInfoDiagramProps = Extract<Page['blocks'][0], { blockType: 'split-info-diagram' }>

function SplitInfoDiagram(block: SplitInfoDiagramProps): ReactElement {
  const { title, subTitle, description, image } = block
  return (
    <Container>
      <Grid className="grid-rows-2 lg:grid-rows-1">
        <div className="col-span-full lg:col-span-6 relative">
          <Asset resource={image as AssetType} imgClassName="object-contain min-h-[400px]" fill />
        </div>

        <div className="col-span-full lg:col-span-6 w-full border-t border-heading flex flex-col pt-8">
          <div className="flex flex-col lg:pr-10">
            <h5 className="mb-1 md:mb-2">{subTitle}</h5>
            <Text className="mb-4" variant="subHeading">
              {title}
            </Text>

            <Text>{description}</Text>
          </div>
        </div>
      </Grid>
    </Container>
  )
}

export default SplitInfoDiagram
